import posthog from 'posthog-js'


export default function startAnalytics(up) {
  const mainElement = document.querySelector('main');
  const posthogId = mainElement.dataset.posthogid;
  const posthogVal = (posthogId + "").trim()
  const posthogUndef = posthogVal === "" || posthogVal=== "undefined"
  
  // Init posthog
  if (posthogUndef) {
    console.info("No PostHog defined, skipping initialization")
  } else {
    posthog.init(posthogId, {
      api_host: 'https://eu.i.posthog.com',
      capture_pageview: false
    })
  }
  
  function trackPageView(url) {
    if (!posthogUndef) {
      posthog.capture('$pageview', {'$current_url': url})
    }
  }
  
  // Track initial page load. Your old tracking code may already do this.
  trackPageView(location.href)
  
  // Track a visit when the address bar changes.
  up.on('up:location:changed', ({ location }) => trackPageView(location))
}
